import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { createGame, backupGame, deleteGame, updateRoundOne, updateVote, updateVoteRound, updateWinners, updateWinnersList, updateRound, updateThisRound } from '../../store/actions/gameActions'
import { Redirect, useHistory } from 'react-router-dom'
import RestaurantSummary from "../restaurants/RestaurantSummary"
import {setImage} from '../layout/SetImage'

function openFinder(project, sortOptions){
    //console.log(Object.keys(this.props.sortOptions.openList));
    for(let key in Object.keys(sortOptions.openList)){
      // console.log(key);
      // console.log(this.props.sortOptions.openList[key]['id']);
        if (project.restaurantId === sortOptions.openList[key]['id'] && sortOptions.openList[key]['isOpen']){
          //console.log(this.props.sortOptions.openList[key]['opensAt']);
          return(true);
        }
      }

    return(false)

  }

function  opensAtFinder(project, sortOptions){
    //console.log(Object.keys(this.props.sortOptions.openList));
    for(var key2 in sortOptions.openList){
      //console.log(key2);
      //console.log(this.props.sortOptions.openList[key2]['id']);
        if (project.restaurantId === sortOptions.openList[key2]['id']){
          return(sortOptions.openList[key2]['opensAt']);
        }
      }
      return("error");
        
  }

function distFinder(restaurantId, distanceList){
      const entries = Object.entries(distanceList);
      for (const entry of entries){
        if (entry[0] === restaurantId)
        return entry[1]
      }
      return ""
    };

function handleDelete(){
  document.getElementById("myModal").style.display = "block";  
}

function handleDeleteGame(props, game, dispatch, history, clearChoices){
  dispatch(backupGame(game));
  dispatch(deleteGame(props.match.params.gameId, ()=>{
    clearChoices();
    history.push("/game/createGame");
    M.updateTextFields();
  }));
}

function handleChoose(choice, setChoiceMade){
  setChoiceMade(choice);
}

function handleRoundOne(gameId, round1Bye, roundOneChoices, dispatch, setOnlyOnce, onlyOnce){
  //console.log('dispatch');
  setOnlyOnce(true);
  if(!onlyOnce){
    dispatch(updateRoundOne(gameId, roundOneChoices, ()=>{console.log('done')}));  
  }  
}

function handleThisRound(gameId, thisRoundBye, round, thisRoundChoices, dispatch){
  //console.log('dispatch');
  dispatch(updateThisRound(gameId, thisRoundBye, round, thisRoundChoices, ()=>{console.log('done')}));  
}

function handleVote(gameId, match, choice, dispatch){
  dispatch(updateVote(gameId, match, choice));
}

function handleVoteRound(gameId, match, choice, round, dispatch){
  dispatch(updateVoteRound(gameId, match, choice, round));
}

function Tournament(props) {
  const thisGame = useSelector((state)=>(state.firestore.data.games && state.firestore.data.games[props.match.params.gameId] && state.firestore.data.games[props.match.params.gameId]));
  const restaurants = useSelector((state)=>state.firestore.data.restaurants);
  const userId = useSelector((state)=>state.firebase.auth.uid);
  const user = useSelector((state)=>state.firestore.data.users[userId]);
  const sortOptions = useSelector((state)=>state.restaurant.sortOptions);
  const dispatch = useDispatch();
  const [onlyOnce, setOnlyOnce] = useState(false);
  const [onlyOnce2, setOnlyOnce2] = useState(false);
  const [onlyOnce3, setOnlyOnce3] = useState(false);
  const [onlyOnce4, setOnlyOnce4] = useState(false);
  const [players, setPlayers] = useState(false);
  const [userDelete, setUserDelete] = useState(false);
  

  const history = useHistory();
    
  const currentGames = useSelector((state)=>state.firestore.data.games);
  
  const [currentGame, setCurrentGame] = useState(false);
  const [winnersPathList, setWinnersPathList] = useState([]);

  const [numOfPlayers, setNumOfPlayers] = useState(2);
  const [numOfChoices, setNumOfChoices] = useState(3);
  const [playerChoices, setPlayerChoices] = useState(Array(numOfChoices).fill(false));
  const [gameName, setGameName] = useState(false);
  const [currentPlayers, setCurrentPlayers] = useState(Array(numOfPlayers).fill(false));
  const settings = {
    numOfPlayers: numOfPlayers,
    numOfChoices: numOfChoices,
    gameName: gameName,
    currentPlayers: currentPlayers
  }
  
  
  const[choiceMade, setChoiceMade] = useState(false);


  useEffect(()=>{
    if(thisGame && thisGame['round']){
  // determine if all votes are in for this round, determine winners if true
        if(thisGame[roundPath2]){
          let byePath = 'round'+thisGame['round']+'Bye';
          let testVotes = Object.entries(thisGame[roundPath2]).map(obj => {
            return( Object.entries(obj[1]).map(itm => { return(!itm[1]) }) )
          })
          let allFalse = testVotes.map(obj=>{
            return(obj.some(itm=>itm));
          })
          let roundOver = !allFalse.some(itm=>itm); 
          if(roundOver && !thisGame[winnersPath]){
            //console.log("ROUND OVER OVER OVER");
            determineWinnersRound(thisGame["round"], thisGame[byePath], dispatch, roundPath2, winnersPath);
          }
        }
      }
    }
  ,[thisGame])

  useEffect(()=>{
    if(thisGame && thisGame['round']){
      // create Choices for next round
      let roundChoices = 'round'+thisGame['round'].toString()+'Choices';  
      //console.log('test');
      //console.log(thisGame[prevWinnersPath]);
      let newChoiceList = [];
      if(thisGame && thisGame[prevWinnersPath] && !thisGame[roundChoices] && userId === thisGame.authorId){
        if(thisGame[prevWinnersPath].length > 1){
          let thisRound = thisGame[prevWinnersPath].reduce(function(result, value, index, array) {
            if (index % 2 === 0)
              result.push(array.slice(index, index + 2));
            return result;
          }, []);      
          let thisRoundChoices = {};
          thisRoundBye = false;
          for(let match in thisRound){
            if(thisRound[match].length === 2){
              thisRoundChoices[restaurants[thisRound[match][0]]['name'] + ' vs ' + restaurants[thisRound[match][1]]['name']] = {};
              thisRoundChoices[restaurants[thisRound[match][0]]['name'] + ' vs ' + restaurants[thisRound[match][1]]['name']]['choices'] = {one:thisRound[match][0],two:thisRound[match][1]};
              for(let player in thisGame['settings']['currentPlayers']){
                thisRoundChoices[restaurants[thisRound[match][0]]['name'] + ' vs ' + restaurants[thisRound[match][1]]['name']][thisGame['settings']['currentPlayers'][player]] = false;
              }       
            }
            else if(thisRound[match].length === 1){
              thisRoundBye = thisRound[match];
            }
          }

          if(!thisGame[roundChoices] && userId === thisGame.authorId){
            //setOnlyOnce3(false);
            handleThisRound(props.match.params.gameId, thisRoundBye, (thisGame.round), thisRoundChoices, dispatch)
          }
        }
      }
    }
  }
  ,[thisGame])


  function clearChoices(){
    setNumOfPlayers(2);
    setNumOfChoices(3);
    setCurrentGame(false);
    setGameName(false);
    setCurrentPlayers(Array(2).fill(false));
  }

  function determineWinners(round, roundBye, dispatch){
    let winners = [];
    if(roundBye){
      winners.push(roundBye[0]);
    }
    for(let obj in Object.entries(thisGame.roundOneChoices)){
      let count1 = 0;
      let count2 = 0;
      for(let itm in Object.entries(thisGame.roundOneChoices)[obj][1]){
        if(Object.entries(thisGame.roundOneChoices)[obj][1][itm]===Object.entries(thisGame.roundOneChoices)[obj][1].choices['one']){
          count1 = count1 + 1;
        }
        else if(Object.entries(thisGame.roundOneChoices)[obj][1][itm]===Object.entries(thisGame.roundOneChoices)[obj][1].choices['two']){
          count2 = count2 + 1;
        }
      }
      //console.log('counts')
      //console.log(count1)
      //console.log(count2)
      //console.log(Object.entries(thisGame.roundOneChoices)[obj][0]);
      if(count1 > count2){
        //console.log(restaurants[Object.entries(thisGame.roundOneChoices)[obj][1].choices['one']].name+' wins')
        winners.push(Object.entries(thisGame.roundOneChoices)[obj][1].choices['one']);
      }
      else if(count1 < count2){
        //console.log(restaurants[Object.entries(thisGame.roundOneChoices)[obj][1].choices['two']].name+' wins')
        winners.push(Object.entries(thisGame.roundOneChoices)[obj][1].choices['two']);
      }
      else if(count1 === count2){
        //console.log('tie');
        if(Math.floor(Math.random() * 2)){
          //console.log(restaurants[Object.entries(thisGame.roundOneChoices)[obj][1].choices['one']].name+' wins');          
          winners.push(Object.entries(thisGame.roundOneChoices)[obj][1].choices['one']);
        }
        else{
          //console.log(restaurants[Object.entries(thisGame.roundOneChoices)[obj][1].choices['two']].name+' wins')
          winners.push(Object.entries(thisGame.roundOneChoices)[obj][1].choices['two']);
        }
      }
      else{
        //console.log('error')
        winners.push('error');
      }  
    }
    handleWinners(winners, round, dispatch, "winnersRound1");
  }

  function determineWinnersRound(round, roundBye, dispatch, thisRoundChoices, winnersPath){
    let count1 = 0;
    let count2 = 0;
    let winners = [];
    if(roundBye){
      winners.push(roundBye[0]);
    }
    for(let obj in Object.entries(thisGame[thisRoundChoices])){
      for(let itm in Object.entries(thisGame[thisRoundChoices])[obj][1]){
        if(Object.entries(thisGame[thisRoundChoices])[obj][1][itm]===Object.entries(thisGame[thisRoundChoices])[obj][1].choices['one']){
          count1 = count1 + 1;
        }
        else if(Object.entries(thisGame[thisRoundChoices])[obj][1][itm]===Object.entries(thisGame[thisRoundChoices])[obj][1].choices['two']){
          count2 = count2 + 1;
        }
      }
      //console.log('counts')
      //console.log(count1)
      //console.log(count2)
      //console.log(Object.entries(thisGame[thisRoundChoices])[obj][0]);
      if(count1 > count2){
        //console.log(restaurants[Object.entries(thisGame[thisRoundChoices])[obj][1].choices['one']].name+' wins')
        winners.push(Object.entries(thisGame[thisRoundChoices])[obj][1].choices['one']);
      }
      else if(count1 < count2){
        //console.log(restaurants[Object.entries(thisGame[thisRoundChoices])[obj][1].choices['two']].name+' wins')
        winners.push(Object.entries(thisGame[thisRoundChoices])[obj][1].choices['two']);
      }
      else if(count1 === count2){
        //console.log('tie');
        if(Math.floor(Math.random() * 2)){
          //console.log(restaurants[Object.entries(thisGame[thisRoundChoices])[obj][1].choices['one']].name+' wins');          
          winners.push(Object.entries(thisGame[thisRoundChoices])[obj][1].choices['one']);
        }
        else{
          //console.log(restaurants[Object.entries(thisGame[thisRoundChoices])[obj][1].choices['two']].name+' wins')
          winners.push(Object.entries(thisGame[thisRoundChoices])[obj][1].choices['two']);
        }
      }
      else{
        //console.log('error')
        winners.push('error');
      }  
    }
    handleWinners(winners, round, dispatch, winnersPath);
  }

  function handleWinners(winners1, thisRound, dispatch, winnersPath){
    //console.log("winnerPath");
    //console.log(winnersPath);
    if(!thisGame.winnersPath && userId === thisGame.authorId){
      //console.log('dispatch2');
      //console.log("round");
      //console.log(thisRound);
      //console.log("winnerPath");
      //console.log(winnersPath);
      dispatch(updateWinners(props.match.params.gameId, winners1, ()=>{console.log('updateWinners')}));
      dispatch(updateRound(props.match.params.gameId, thisRound+1, ()=>{console.log('updateRound')}));
      dispatch(updateWinnersList(props.match.params.gameId, winnersPath,  winners1, ()=>{console.log('updateWinnersList')})); 
    }
    //history.push("/bracket/"+props.match.params.gameId)
  }

  function closeFunction(){
    if(document.getElementById("myModal")){
      document.getElementById("myModal").style.display = "none";
    }
  }

  // if the game id doesn't match a game in the firestore database, redirect to createGame
  if(currentGames && !currentGames[props.match.params.gameId]){
    return <Redirect to={'/game/createGame'} />
  }

  if(currentGames === null){
    return <Redirect to={'/game/createGame'} />   
  }

  let thisRoundBye = false;
  let roundPath2 = false;
  let winnersPath = false;
  let prevWinnersPath = false;
  if(thisGame && thisGame["round"]){
    roundPath2 = "round"+(thisGame["round"])+"Choices";
    winnersPath = "winnersRound" + (thisGame['round']);
    prevWinnersPath = "winnersRound" + (thisGame['round']-1);  
  }

  


  if(thisGame){
    let allChoices = [];
    Object.entries(thisGame["playerChoices"]).map(obj=>{
        obj[1].map(itm=>{
          if(!allChoices.includes(itm)){
            allChoices.push(itm)  
          }
          
        })
      })

    let roundOne = allChoices.reduce(function(result, value, index, array) {
        if (index % 2 === 0)
          result.push(array.slice(index, index + 2));
        return result;
      }, []);
    
    let roundOneChoices = {};
    let roundOneBye = false;

    for(let match in roundOne){
      if(roundOne[match].length === 2){
        roundOneChoices[restaurants[roundOne[match][0]]['name'] + ' vs ' + restaurants[roundOne[match][1]]['name']] = {};
        roundOneChoices[restaurants[roundOne[match][0]]['name'] + ' vs ' + restaurants[roundOne[match][1]]['name']]['choices'] = {one:roundOne[match][0],two:roundOne[match][1]};
        for(let player in thisGame['settings']['currentPlayers']){
          roundOneChoices[restaurants[roundOne[match][0]]['name'] + ' vs ' + restaurants[roundOne[match][1]]['name']][thisGame['settings']['currentPlayers'][player]] = false;
        }      
      }
      else if(roundOne[match].length === 1){
          roundOneBye = roundOne[match];
          //console.log('roundOneBye');
          //console.log(roundOneBye);
        }
    }


    if(!thisGame['roundOneChoices'] && userId === thisGame.authorId && !onlyOnce){
      handleRoundOne(props.match.params.gameId, roundOneBye, roundOneChoices, dispatch, setOnlyOnce, onlyOnce)
    }
    //let allChoices = thisGame["playerChoices"].map


    if (!userId) return <Redirect to='/signin' />


    // redirect for restaurant choice if button is pressed
    if(choiceMade !== false){
      return <Redirect to={'/chooseRestaurant/' + props.match.params.gameId + '/' + choiceMade} />
    }

    // set currentGame to gameId in params if exists, otherwise redirect to createGame
    if(currentGames && currentGames[props.match.params.gameId] && currentGame !== currentGames[props.match.params.gameId]){
      setCurrentGame(currentGames[props.match.params.gameId]);
    }
    else if (currentGames && !currentGames[props.match.params.gameId]){
      return <Redirect to={'/game/createGame'} />  
    }

    // load game settings if there is a game
    if(currentGames && userId && currentGame){
      if(numOfPlayers!==currentGame.settings.numOfPlayers){
        setNumOfPlayers(currentGame.settings.numOfPlayers);  
      }
      if(numOfChoices!==currentGame.settings.numOfChoices){
        setNumOfChoices(currentGame.settings.numOfChoices);
      }
      if(gameName!==currentGame.settings.gameName){
        setGameName(currentGame.settings.gameName);
      }
      if(currentPlayers!==currentGame.settings.currentPlayers){
        setCurrentPlayers(currentGame.settings.currentPlayers);
      }
      if(playerChoices.length !== numOfChoices){
        setPlayerChoices(Array(numOfChoices).fill(false));    
      }
    }

    if(currentGame && players !== currentGame.settings['currentPlayers']){
      setPlayers(currentGame.settings['currentPlayers']);
    }
    
    var choicesFull = !playerChoices.some(obj => !obj);
    

    //determine if all votes have been cast in round ONE
    if(thisGame.roundOneChoices){
      let testVotes = Object.entries(thisGame.roundOneChoices).map(obj => {
        return( Object.entries(obj[1]).map(itm => { return(!itm[1]) }) )
      })
      let allFalse = testVotes.map(obj=>{
        return(obj.some(itm=>itm));
      })
      let roundOver = !allFalse.some(itm=>itm);  
    
      if(roundOver && !onlyOnce2 && !thisGame["winnersRound1"] && !onlyOnce4){
        //console.log("BYEBYE");
        //console.log(roundOneBye);
        setOnlyOnce4(true);
        determineWinners(1, roundOneBye, dispatch);
      }
    }

    

  }

  let roundPath = false;
  let winnersPath2 = false;
  if(thisGame && thisGame["round"]){
    roundPath = "round"+(thisGame["round"])+"Choices";
    winnersPath2 = "winnersRound"+thisGame["round"];
    //console.log('roundPath');
    //console.log(roundPath);
  }

  let voteList = [];
  let voteList2 = [];
  if(thisGame && thisGame['round'] && thisGame[roundPath]){
    Object.entries(thisGame[roundPath]).map(obj=>{
    if(!obj[1][userId]){
      voteList2.push(obj)}
    });
    voteList2.sort();  
  }
  else if(thisGame && thisGame.roundOneChoices){
    Object.entries(thisGame.roundOneChoices).map(obj=>{
    if(!obj[1][userId]){
      voteList.push(obj)}
    });
    voteList.sort();
  }
  //console.log("vote lists")
  //console.log(voteList)
  //console.log(voteList2)

  const waitingOnList = [];
  if(thisGame && thisGame['round'] && thisGame[roundPath]){
    for(let player in thisGame['settings']['currentPlayers']){
      //console.log(thisGame['settings']['currentPlayers'][player]);
      let waitingArray = Object.entries(thisGame[roundPath]).map(obj=>{
              return(!obj[1][thisGame['settings']['currentPlayers'][player]])
            });
      if(waitingArray.some(itm=>itm)){
        waitingOnList.push(thisGame['settings']['currentPlayers'][player])
      }
    }
  }
  else if(thisGame && thisGame.roundOneChoices){
   for(let player in thisGame['settings']['currentPlayers']){
      //console.log(thisGame['settings']['currentPlayers'][player]);
      let waitingArray2 = Object.entries(thisGame.roundOneChoices).map(obj=>{
              return(!obj[1][thisGame['settings']['currentPlayers'][player]])
            })
      if(waitingArray2.some(itm=>itm)){
        waitingOnList.push(thisGame['settings']['currentPlayers'][player])
      }
    } 
  }
  if(!waitingOnList.includes(thisGame['authorId']) && thisGame && thisGame['round'] && !thisGame[winnersPath2] && thisGame[prevWinnersPath] && thisGame[prevWinnersPath].length !== 1){
    waitingOnList.push(thisGame['authorId'])
  }
  
  if(thisGame && thisGame['timestamp']){
    //console.log(((Date.now()/1000)-thisGame['timestamp']['seconds'])/60);
    if(( !userDelete && (((Date.now()/1000)-thisGame['timestamp']['seconds'])/60)>10)){
      setUserDelete(true);
    }
  }

  return (
    <>
      <div style={{display:"flex", flexFlow:"column"}}>
        <div id="myModal" className="modal2">
                <div className="modal-content2">
                  <span className="close2" onClick={()=>{closeFunction()}}>&times;</span>
                  <p>Are you sure you want to delete?</p>
                  { 
                  <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{handleDeleteGame(props, currentGame, dispatch, history, clearChoices)}}>Delete</button>
                  </div>
                  }
              </div>
        </div>

        { thisGame && thisGame[prevWinnersPath] && (thisGame[prevWinnersPath].length === 1) &&
          <div style={{display:"flex", flexFlow:"row", justifyContent:'center', padding:'10px'}}>
            {setImage(restaurants[thisGame[prevWinnersPath][0]]['primaryTag'])}
            <p style={{textAlign:"center"}}>{restaurants[thisGame[prevWinnersPath][0]].name} wins</p>
          </div>
        }

        { thisGame && thisGame.winners &&
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={()=>{
              history.push("/bracket/"+props.match.params.gameId)
            }}>{"View Results"}</button>
          </div>
        }

        { thisGame && thisGame[prevWinnersPath] && (thisGame[prevWinnersPath].length !== 1) &&
          <h5 style={{textAlign:"center"}}>{"Round " + thisGame['round']}</h5>
        }

        { voteList && voteList !== [] && voteList[0] && sortOptions && user &&
            <div key={voteList[0][0]}>
              <p style={{textAlign:"center"}}>{voteList[0][0]}</p>
              <div >
                <div style={{display:"flex", flexFlow:"column", "justifyContent": "center"}}>
                  <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
                    <RestaurantSummary key = { restaurants[voteList[0][1]["choices"]["one"]].restaurantId } isOpen = {openFinder(restaurants[voteList[0][1]["choices"]["one"]], sortOptions)} opensAt = {opensAtFinder(restaurants[voteList[0][1]["choices"]["one"]], sortOptions)} distance = {distFinder(restaurants[voteList[0][1]["choices"]["one"]].restaurantId, user.distanceList)} onFavorite = {false} project={restaurants[voteList[0][1]["choices"]["one"]]} allContent = {""} favorite = {false}/>
                  </div>
                  <div key={"choiceButton"} className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{
                      handleVote(props.match.params.gameId, voteList[0][0], voteList[0][1]["choices"]["one"], dispatch);
                    }}>{"Vote"}</button>
                  </div>
                </div>
                <div style={{display:"flex", flexFlow:"column"}}>
                  <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
                    <RestaurantSummary key = { restaurants[voteList[0][1]["choices"]["two"]].restaurantId } isOpen = {openFinder(restaurants[voteList[0][1]["choices"]["two"]], sortOptions)} opensAt = {opensAtFinder(restaurants[voteList[0][1]["choices"]["two"]], sortOptions)} distance = {distFinder(restaurants[voteList[0][1]["choices"]["two"]].restaurantId, user.distanceList)} onFavorite = {false} project={restaurants[voteList[0][1]["choices"]["two"]]} allContent = {""} favorite = {false}/>
                  </div>
                  <div key={"choiceButton"} className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{
                      handleVote(props.match.params.gameId, voteList[0][0], voteList[0][1]["choices"]["two"], dispatch);
                    }}>{"Vote"}</button>
                  </div>
                </div>
              </div>
              </div>
        }

        { voteList2 && voteList2 !== [] && voteList2[0] && sortOptions && user &&
            <div key={voteList2[0][0]}>
              <p style={{textAlign:"center"}}>{voteList2[0][0]}</p>
              <div >
                <div style={{display:"flex", flexFlow:"column", "justifyContent": "center"}}>
                  <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
                    <RestaurantSummary key = { restaurants[voteList2[0][1]["choices"]["one"]].restaurantId } isOpen = {openFinder(restaurants[voteList2[0][1]["choices"]["one"]], sortOptions)} opensAt = {opensAtFinder(restaurants[voteList2[0][1]["choices"]["one"]], sortOptions)} distance = {distFinder(restaurants[voteList2[0][1]["choices"]["one"]].restaurantId, user.distanceList)} onFavorite = {false} project={restaurants[voteList2[0][1]["choices"]["one"]]} allContent = {""} favorite = {false}/>
                  </div>
                  <div key={"choiceButton"} className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{
                      handleVoteRound(props.match.params.gameId, voteList2[0][0], voteList2[0][1]["choices"]["one"], thisGame.round, dispatch);
                    }}>{"Vote"}</button>
                  </div>
                </div>
                <div style={{display:"flex", flexFlow:"column"}}>
                  <div style={{"display": "flex", "justifyContent": "center", "padding": "10px"}}>
                    <RestaurantSummary key = { restaurants[voteList2[0][1]["choices"]["two"]].restaurantId } isOpen = {openFinder(restaurants[voteList2[0][1]["choices"]["two"]], sortOptions)} opensAt = {opensAtFinder(restaurants[voteList2[0][1]["choices"]["two"]], sortOptions)} distance = {distFinder(restaurants[voteList2[0][1]["choices"]["two"]].restaurantId, user.distanceList)} onFavorite = {false} project={restaurants[voteList2[0][1]["choices"]["two"]]} allContent = {""} favorite = {false}/>
                  </div>
                  <div key={"choiceButton"} className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
                    <button className="btn pink lighten-1" onClick={()=>{
                      handleVoteRound(props.match.params.gameId, voteList2[0][0], voteList2[0][1]["choices"]["two"], thisGame.round, dispatch);
                    }}>{"Vote"}</button>
                  </div>
                </div>
              </div>
            </div>
        }

        { voteList2 && voteList2.length === 0 && sortOptions && user && waitingOnList && waitingOnList.length === 0 &&
          thisGame && !thisGame[prevWinnersPath] &&
          <div>
            <p style={{textAlign:"center"}}>Waiting on tournament creator.</p>
          </div>
        }

        { waitingOnList && waitingOnList.length !== 0 && thisGame && thisGame['settings'] &&
          <div>
            <p style={{textAlign:"center"}}>Waiting on...</p>
          {
            waitingOnList.map(player=>{
            return(
              <p key={player} style={{textAlign:"center"}}>{thisGame['settings']['currentNames'][player]}</p>
                          )
          })  
          }
          </div>
        }

        { (currentGame['authorId'] === userId || userDelete) &&
        <div>
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={()=>{handleDelete()}}>Delete Game</button>
          </div>
        </div>
        }


        
      </div>
    </>
  );
}

export default Tournament;